import React from 'react'

import DatePicker from 'common/DatePicker'
import FormControlled from 'common/Forms/Base/FormControlled'

export default props => <FormControlled tag={DatePicker} {...props} />
